import ConfigurationService from "../../../services/ConfigurationService";

export default {
  namespaced: true,

  state: {
    shop: null,
  },

  getters: {
    get: state => {
      return state.shop;
    },
  },

  mutations: {
    set: (state, payload) => {
      state.shop = payload;
    },
  },

  actions: {
    init({commit}) {
      const shop = ConfigurationService.option('shop');

      commit('set', shop || window.Shopify.shop);
    },
  },
};
